import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

// Template164: Metro de París. Todo desde backend.
// page.texts[0]=header, [1]=intro | page.sections[0]=apps (title, content, tooltipBox.text, stickerImageId), [1]=consejos, [2]=importante (content), [3]=lineas | page.canvasImages (subway-sticker)
const Template164 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found) return found.imageUrl ?? found.url;
		}
		return undefined;
	};

	const headerText = page?.texts?.[0]?.content;
	const introText = page?.texts?.[1]?.content;

	const sections = Array.isArray(page?.sections) ? page.sections : [];
	const section0 = sections[0];
	const section1 = sections[1];
	const section2 = sections[2];
	const section3 = sections[3];

	const subwaySticker = getCanvasImageUrl("subway-sticker");

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: "12px",
		marginTop: 0,
		color: "#2C3E50",
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				height: "100vh",
				display: "flex",
				flexDirection: "column",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					height: "100%",
					backgroundColor: backgroundColor || "#f7f7f7",
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				}}
			>
				{headerText && (
					<Box
						data-block-id="header"
						data-template-header
						sx={{
							backgroundColor: headerBackgroundColor || "#2C3E50",
							color: headerTextColor || "#fff",
							textAlign: "center",
							padding: "15px 0",
							fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
							fontSize: "14px",
							fontWeight: 600,
							flexShrink: 0,
							position: "sticky",
							top: 0,
							zIndex: 99999,
						}}
					>
						{headerText}
					</Box>
				)}

				{introText && (
					<Box data-block-id="text-1" sx={{ padding: "12px 16px", fontSize: 13, color: "#444" }}>
						<Box component="p" sx={estiloP}>
							{introText}
						</Box>
					</Box>
				)}

				{section0 && (
					<Box
						data-block-id="text-2"
						sx={{
							backgroundColor: "#E8F4F8",
							border: "2px solid #2C3E50",
							borderRadius: "16px",
							padding: "16px",
							margin: "0 16px 16px 16px",
							position: "relative",
							boxSizing: "border-box",
						}}
					>
						{section0.title && (
							<Box component="h3" sx={estiloH3}>
								{section0.title}
							</Box>
						)}
						{section0.content && (
							<Box
								component="div"
								dangerouslySetInnerHTML={{ __html: section0.content }}
								sx={{ paddingLeft: "18px", margin: 0, fontSize: 13 }}
							/>
						)}
					</Box>
				)}

				{section1 && (
					<Box
						data-block-id="text-3"
						sx={{
							padding: "0 16px",
							fontSize: 13,
							color: "#444",
							position: "relative",
						}}
					>
						{section1.title && (
							<Box component="h3" sx={estiloH3}>
								{section1.title}
							</Box>
						)}
						{section1.content && (
							<Box
								component="div"
								dangerouslySetInnerHTML={{ __html: section1.content }}
								sx={{ paddingLeft: "18px" }}
							/>
						)}
					</Box>
				)}

				{section2?.content && (
					<Box data-block-id="text-4" sx={{ padding: "0 16px", position: "relative" }}>
						{subwaySticker && (
							<Box
								component="img"
								src={subwaySticker}
								alt=""
								sx={{
									width: 110,
									position: "absolute",
									bottom: isSmallScreen ? -120 : -120,
									right: isSmallScreen ? -20 : -20,
								}}
							/>
						)}
						{section0.tooltipBox?.text && (
							<Box
								component="div"
								dangerouslySetInnerHTML={{
									__html: section0.tooltipBox.text,
								}}
								sx={{
									position: "absolute",
									bottom: isSmallScreen ? -80 : -80,
									right: isSmallScreen ? 60 : 60,
									backgroundColor: "#fff8db",
									border: "2px solid #f5c400",
									borderRadius: "16px 16px 0px 16px",
									padding: "10px 12px",
									fontSize: 11,
									fontFamily: `${
										fontFamily || "'Poppins', sans-serif"
									} !important`,
									color: "#444",
									boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
									maxWidth: isSmallScreen ? 220 : 112,
								}}
							/>
						)}
						<Box
							sx={{
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "12px",
								padding: "10px 12px",
								marginTop: "8px",
								fontSize: 12,
								fontFamily: `${
									fontFamily || "'Poppins', sans-serif"
								} !important`,
								color: "#444",
							}}
						>
							<Box
								component="div"
								dangerouslySetInnerHTML={{ __html: section2.content }}
							/>
						</Box>
					</Box>
				)}

				{section3 && (
					<Box
						data-block-id="text-5"
						sx={{
							padding: "12px 16px",
							fontSize: 13,
							color: "#444",
							marginTop: "2px",
							position: "relative",
						}}
					>
						{section3.title && (
							<Box component="h3" sx={estiloH3}>
								{section3.title}
							</Box>
						)}
						{section3.content && (
							<Box
								component="div"
								dangerouslySetInnerHTML={{ __html: section3.content }}
								sx={{ paddingLeft: "18px" }}
							/>
						)}
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template164.thumbnail = "/images/template-1.png";

export default Template164;
